import { render, staticRenderFns } from "./v-switch-card.vue?vue&type=template&id=4e61c698&scoped=true"
import script from "./v-switch-card.vue?vue&type=script&lang=js"
export * from "./v-switch-card.vue?vue&type=script&lang=js"
import style0 from "./v-switch-card.vue?vue&type=style&index=0&id=4e61c698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e61c698",
  null
  
)

export default component.exports